import { useMutation } from "react-query";

import type { AddressStored } from "@jti/fe-common";
import type { BuyPrizeElementResponseType } from "@jti/rest-api-types";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import type { RestResponseType } from "../../../services";
import { LoyaltyApiEvo } from "../../../services/loyalty";

type HandlePurchasePrizePayload = {
  consumer_uuid: string;
  prize_uuid: string;
  quantity: number;
  ciam_token: string;
  address?: AddressStored;
};

export const usePurchaseLoyaltyPrize = () => {
  const { isError, isLoading, mutateAsync, error, reset, data } = useMutation<
    RestResponseType<BuyPrizeElementResponseType>,
    Error & { error_code?: string },
    HandlePurchasePrizePayload
  >(MUTATION_KEYS.purchaseLoyaltyPrize, async ({ ciam_token, consumer_uuid, prize_uuid, quantity, address }) => {
    const loyaltyClient = LoyaltyApiEvo.init();
    const data = await loyaltyClient.buyPrize(consumer_uuid, prize_uuid, quantity, ciam_token, address);
    return data;
  });

  return {
    data,
    reset,
    error,
    isError,
    isLoading,
    purchaseLoyaltyPrize: mutateAsync,
  };
};
